<!--

TODO
  - On rewrite implement debounce option here and consider https://www.npmjs.com/package/vue-debounce

-->


<template>
  <div
    :style="cssVars"
    :class="{
      flat,
      'no-hover': noHover,
    }">
    <div class="search-wrapper">
      <b-form-input
        ref="searchQueryRef"
        v-model="searchQuery"
        type="text"
        autocomplete="off"
        class="sb2-bordered sb2-hoverable sb2-focusable"
        :class="{'w-100': fullWidth, 'no-prefix': noPrefixIcon }"
        :placeholder="placeholder"
        @input="input" />
      <!-- <span
        class="sb2-icon search-light"
        :class="{'size-14': iconSize === 12}" /> -->
      <SBIcon
        v-if="!noPrefixIcon"
        class="sb2-icon"
        :icon="SBIconList.MAGNIFIER"
        :color="SBColors.blackUltralight"
        :size="iconSize"
        :border-radius="50" />
      <SBIcon
        v-if="searchQuery"
        class="clear-text"
        :icon="SBIconList.CLOSE_THIN"
        :color="SBColors.blackUltralight"
        :hover-icon-color="SBColors.blackPrimary"
        :hover-color="SBColors.greyBorderSecondary"
        :size="8"
        :hover-size="18"
        :border-radius="50"
        :pointer="true"
        @click.native.stop
        @click="clear" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AsYouType } from 'libphonenumber-js/max';
import { position } from 'caret-pos';
import { debounce } from 'debounce';

import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';

export default {
  name: 'SearchInput',
  components: {
    SBIcon,
  },
  props: {
    placeholder: {
      type: String,
      required: false,
      default: 'Search...',
    },
    noDebounce: {
      type: Boolean,
      required: false,
      default: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    noHover: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconSize: {
      type: Number,
      required: false,
      default: 14,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    noPrefixIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      searchQuery: '',
      preventSearchContactValueChange: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      userRegion: 'user/region',
    }),
    cssVars() {
      return {
        '--icon-size': `${this.iconSize}px`,
      };
    },
    searchIsNumber() {
      const regex = /^[+\-()0-9\s]+$/;
      return regex.test(this.searchQuery);
    },
  },
  watch: {
    searchQuery() {
      const startsWith00 = /^00/.test(this.searchQuery);
      const tempValue = this.searchQuery.replace(/^00/, '+');
      if (this.preventSearchContactValueChange) {
        this.preventSearchContactValueChange = false;
        return;
      }
      this.caretPosition = position(this.$refs.searchQueryRef.$el).pos;
      const currentInput = this.searchQuery.toString();
      const uptoCarretNoSpace =
        currentInput
          .substring(0, this.caretPosition)
          .replaceAll(' ', '')
          .split('')
          .join('\\s*')
          .replaceAll('\\\\', '\\')
          .replaceAll('+', '\\+');
      if (!this.searchIsNumber) {
        return;
      }

      const asYouTypeInstance = new AsYouType(this.userRegion);
      asYouTypeInstance.input(tempValue);
      const outputValue = startsWith00 ? `00 ${asYouTypeInstance.formattedOutput.replace(/^\+/, '')}` : asYouTypeInstance.formattedOutput;

      this.searchQuery = outputValue;
      this.preventSearchContactValueChange = true;
      setTimeout(() => {
        this.preventSearchContactValueChange = false;
      });

      this.$nextTick(() => {
        const matchCarretPos = this.searchQuery.match(uptoCarretNoSpace);
        if (matchCarretPos) {
          this.$refs.searchQueryRef.$el.setSelectionRange(matchCarretPos[0].length, matchCarretPos[0].length);
        }
      });
    },
    value() {
      this.searchQuery = this.value;
    },
  },
  methods: {
    change() {
      this.$emit('change', this.searchQuery);
    },
    clear() {
      this.searchQuery = '';
      this.$emit('input', this.searchQuery);
      this.change();
    },
    input() {
      if (this.noDebounce) {
        this.$emit('input', this.searchQuery);
      } else {
        this.inputDebounce();
      }
    },
    inputDebounce: debounce(function f() {
      this.$emit('input', this.searchQuery);
    }, '500'),
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  position: relative;
  margin-right: 10px;

  input[type=text] {
    position: relative;
    box-sizing: border-box;
    height: 30px;
    width: 296px;
    padding-left: 38px;
    padding-right: 30px;
    font-size: 14px;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    border: solid 1px #cfd8dc;
    border-radius: 5px;

    &::placeholder {
      color: $greyPrimary !important;
    }

    &:hover {
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
    }

    &:focus {
      outline: none !important;
      border: solid 1px #cfd8dc;
      box-shadow: 0 0 0 3px #bfdeff !important;
    }

    &.no-prefix {
      padding-left: 8px;
    }
  }

  .sb2-icon {
    // move icon inside input element
    position: absolute;
    left: 0;
    top: calc(50% - (var(--icon-size) / 2));
    margin-left: 16px;
    margin-right: 8px;
  }

  .clear-text {
    position: absolute;
    top: 7px;
    right: 7px;
  }
}

.flat .search-wrapper {
  margin-right: 0px !important;

  input, input.form-control {
    padding-left: 22px !important;
    padding-right: 24px !important;
    box-shadow: none !important;
    border: none !important;
    background-color: transparent !important;

    &:focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  .sb2-icon {
    margin-left: 0px !important;
  }

  .clear-text {
    right: 0px !important;
  }
}

.flat.no-hover {
  input.form-control:hover {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }
}
</style>
